import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false
      })
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    chartdata: function () {
      this.renderChart(this.chartdata, this.options, this.plugins)
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options, this.plugins)
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/doughnut.js